import React, { useMemo, useState, useEffect, useRef } from "react";
import styles from "../styles/Login.module.css";
import { loginSVGs } from "../utils/loginSVGs";
import titleSections from "../utils/titleSections";

import {
  Button,
} from '@mui/material';

const LeftWrapper = () => {
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);

  const reduceMotion = useMemo(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches,
    []
  );

  useEffect(() => {
    if (reduceMotion) return;

    const startTimer = () => {
      timerRef.current = setInterval(() => {
        setIndex((i) => (i + 1) % titleSections.length);
      }, 8000);
    };

    startTimer();
    return () => clearInterval(timerRef.current);
  }, [reduceMotion]);

  const handleDotClick = (i) => {
    setIndex(i);
    if (!reduceMotion) {
      clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        setIndex((prev) => (prev + 1) % titleSections.length);
      }, 8000);
    }
  };

  return (
    <div className={styles.leftWrapper}>
      <section className={styles.sectionsWrapper}>
        {titleSections.map((section, i) => (
          <article
            key={i}
            className={`${styles.slide} ${
              i === index ? styles.slideActive : ""
            }`}
            role="group"
            aria-roledescription="slide"
            aria-label={`${i + 1} of ${titleSections.length}`}
          >
            <span className={styles.sectionTitle}>{section.title}</span>
            <span className={styles.sectionDescription}>
              {section.description}
            </span>
          </article>
        ))}
        <div className={styles.dots}>
          {titleSections.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Go to slide ${i + 1}`}
              aria-current={i === index}
              onClick={() => handleDotClick(i)}
              className={`${styles.dot} ${i === index ? styles.dotActive : ""}`}
            />
          ))}
        </div>
      </section>
      <span className={styles.loginTitle}>
        <loginSVGs.appIcon
          width="clamp(58px, 9.2vw, 210px)"
          height="clamp(58px, 4.2vw, 90px)"
        />
      </span>
      <span className={styles.bottomCircle}>
        <loginSVGs.bottomCircle width="12vw" height="auto" />
      </span>
      <span className={styles.topCircle}>
        <loginSVGs.topCircle width="7vw" height="auto" />
      </span>
      {/* <span className={styles.lineIcons}>
        <loginSVGs.lineIcons width="10.1vw" height="auto" />
      </span> */}

      <div className={styles.toolbox}>
        <Button
          variant="outlined"
          className={styles.licenseKey}
          onClick={() => window.location.href = "/license_key"}
          sx={{ mb: 1, borderColor: 'rgba(255, 255, 255, 0.3)', color: '#fff' }}
        >
          License Key
        </Button>
      </div>
    </div>
  );
};

export default LeftWrapper;
